import { SxProps, Theme } from '@mui/system';

const styles = {
  content: {
    pt: 0,
  },
  tooltipRow: {
    display: 'flex',
    flexDirection: 'row',
  },
  tooltipLabel: {
    fontSize: 14,
    mr: '3px',
    fontWeight: '500',
  },
  tooltipValue: {
    fontSize: 14,
  },
  title: {
    fontSize: 20,
    mt: 0,
    pt: 0,
    borderBottom: 0,
    color: 'primary.main',
    fontWeight: '600',
    mb: 1,
  },
  emailContainer: { display: 'flex', flexDirection: 'row', ml: 1.5 },
  row: {
    borderBottom: '1px solid',
    borderColor: 'grey.100',
    padding: 2,
    pt: 1,
    pl: 0,
    backgroundColor: 'common.white',
  },
  labelRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  },
  labelTextGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    flex: 1.5,
  },
  label: {
    fontWeight: 600,
    fontSize: 14,
    color: 'common.grey850',
  },
  recommended: {
    fontSize: 12,
    color: 'grey.600',
  },
  infoIcon: {
    fontSize: 18,
    color: 'grey.600',
    cursor: 'pointer',
  },
  clearButton: {
    padding: 0,
    position: 'absolute',
    top: -6,
    right: -13,
  },
  clearIcon: {
    fontSize: 14,
    color: 'grey.500',
  },
  fileRow: {
    position: 'relative',
    marginTop: 1,
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    flexWrap: 'wrap',
  },
  fileNameButton: {
    padding: 0,
    margin: 0,
    border: 'none',
    fontSize: 12,
    background: 'none',
    textDecorationLine: 'underline',
    color: 'primary.main',
    cursor: 'pointer',
  },
  fileHint: {
    fontSize: 12,
    color: 'grey.600',
  },
  actionsInline: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    flex: 1,
    gap: 1,
  },
  testEmailRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    marginTop: 2,
    flexWrap: 'wrap',
  },
  testEmailLabel: {
    fontWeight: 600,
    fontSize: 13,
    color: 'common.grey850',
  },
  testEmailInput: {
    minWidth: 260,
  },
  footer: {
    px: 3,
    pb: 3,
  },
  hiddenInput: {
    display: 'none',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
